import { API } from "@/lib/api";

export async function transcribeAudio(blob) {
  const fd = new FormData();
  fd.append("audio", blob, "recording.webm");
  const res = await fetch(`${API}/ai/stt`, { method: "POST", body: fd });
  if (!res.ok) {
    let detail = "Voice transcription is unavailable right now.";
    try { detail = (await res.json()).detail || detail; } catch { /* keep default */ }
    throw new Error(detail);
  }
  return (await res.json()).text;
}

export async function synthesizeSpeech(text) {
  const res = await fetch(`${API}/ai/tts`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text: text.slice(0, 4000) }),
  });
  if (!res.ok) {
    let detail = "Voice playback is unavailable right now.";
    try { detail = (await res.json()).detail || detail; } catch { /* keep default */ }
    throw new Error(detail);
  }
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
